import * as styles from "@faire/retailer-visitor-shared/components/SearchProducts/SingleProductRowPlaceholder/styles.css";
import { ResponsiveValues } from "@faire/web--source/slate/Theme/ResponsiveValues";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import range from "lodash/range";
import * as React from "react";

export const ROWS_PER_BATCH = 2;

interface IProps {
  itemsPerRowResponsive: ResponsiveValues<number>;
}

export const SingleProductRowPlaceholder: React.FC<IProps> = ({
  itemsPerRowResponsive,
}) => {
  const vars = assignInlineVars({
    [styles.mobileColumnsVar]: String(itemsPerRowResponsive.mobileAndAbove + 1),
    [styles.tabletColumnsVar]: String(
      (itemsPerRowResponsive.tabletAndAbove ?? 2) + 1
    ),
    [styles.desktopColumnsVar]: String(
      (itemsPerRowResponsive.desktopAndAbove ?? 5) + 1
    ),
    [styles.xLargeColumnsVar]: String(
      (itemsPerRowResponsive.xLargeAndAbove ?? 6) + 1
    ),
  });

  return (
    <>
      {range(ROWS_PER_BATCH).map((value) => (
        <div
          className={styles.rowPlaceholderWrapper}
          style={vars}
          key={value}
          data-test-id={`single-row-placeholder-${value}`}
        />
      ))}
    </>
  );
};
